import {createApi} from '@reduxjs/toolkit/query/react';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/API/responseMiddleware';

const projectTypeAPI = createApi({
    reducerPath:"projectTypeAPI",
    baseQuery:customFetchBase,
    endpoints:(builder)=>({

        getAllProjectTypes:builder.mutation({
            query:(data)=>({
                url:"/ProjectType/GetAllProjectTypes",
                method:"POST",
                body:transformRequest(data)
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse,
        }),
        addProjectType: builder.mutation({
            query:(data) => ({
                url: `/ProjectType/AddProjectType`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProjectTypeById: builder.query({
            query: (projectTypeId) => ({
                url: `/ProjectType/GetProjectTypeById?projecttypeid=${projectTypeId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        updateProjectType: builder.mutation({
            query: (data) => ({
                url: '/ProjectType/UpdateProjectType',
                method: 'POST',
                body: transformRequest(data)
            }), 
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteProjectType:builder.mutation({
            query:(projectTypeId)=>({
                url:`/ProjectType/DeleteProjectType?projecttypeid=${projectTypeId}`,
                method:'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const {
 useGetAllProjectTypesMutation,
 useAddProjectTypeMutation,
 useLazyGetProjectTypeByIdQuery,
 useUpdateProjectTypeMutation,
 useDeleteProjectTypeMutation
} = projectTypeAPI;

export default projectTypeAPI